import { Injectable } from "@angular/core";
import { BaseWorkflowStateService } from "../base-workflow-state.service";
import { WirelessFlow } from "../../../../../../models/order/workflow/wireless/wireless-flow.model";
import { ProductStatusType, StepStatusType } from "../../../../../../models/order/order.model";

@Injectable({ providedIn: 'root' })
export class WirelessFlowStateService extends BaseWorkflowStateService<WirelessFlow> {
    override stateKey: string = 'wirelessFlow';

    updateStatus(value: ProductStatusType) {
        this.updateData({ status: this.mapProductStatusToFlowStatus(value) });
    }

    private mapProductStatusToFlowStatus(status: ProductStatusType): StepStatusType {
        switch (status) {
            case ProductStatusType.COMPLETED:
                return StepStatusType.Completed;
            case ProductStatusType.STARTED_BUT_NOT_FINISHED:
                return StepStatusType.InProgress;
            case ProductStatusType.REQUIRES_ATTENTION:
                return StepStatusType.RequiresAttention;
            case ProductStatusType.NOT_AVAILABLE:
                return StepStatusType.NotAvailable;
            case ProductStatusType.AVAILABLE_NOT_STARTED:
                return StepStatusType.AvailableNotStarted;
            default:
                return StepStatusType.InProgress;
        }
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}